const getRandomRequestId = (): string => {
  return `${Math.floor(100 + Math.random() * 90000)}-${Math.floor(100000000 + Math.random() * 900000000)}`;
};

export default getRandomRequestId;
